﻿import buttonLoader from '../utilities/buttonLoader.js';

var courseWaitingList = {};

courseWaitingList = {

  init: function () {
    var me = this;
    var form = document.querySelector('.courseWaitingListForm')

    if (form) {
      me.bind(form);
    }

  },

  bind: function (form) {
    var me = this;


    form.addEventListener('submit', function (e) {

      e.preventDefault();

      var m = form.querySelector('.alert');

      if (m) {
        m.remove();
      }

      me.submit(form);

    });
  },

  submit: function (form) {
    const me = this;

    const button = form.querySelector('button[type=submit]');

    buttonLoader.start(button);

    const data = new FormData(form)
    const xhr = new XMLHttpRequest();
    xhr.open(form.getAttribute("method"), form.getAttribute("action"));

    xhr.onload = function () {
      var resp = JSON.parse(xhr.response);

      if (xhr.status >= 200 && xhr.status < 300) {

        if (resp.success) {
          window.location.reload()

        } else {

          buttonLoader.reset(button);

          me.renderMessage(button, resp.message, 'error');
        }

      } else {

        buttonLoader.reset(button);

        me.renderMessage(button, 'Server error', 'error');
      }

    };

    xhr.send(data);
  },

  renderMessage: function (el, message, type) {
    el.insertAdjacentHTML('afterend', '<div class="alert ' + type + '">' + message + '</div>');

  },

};

courseWaitingList.initialize = function () {
  courseWaitingList.init();
};

module.exports = courseWaitingList;
